module.exports = __webpack_public_path__ + "static/image/service/pc/ceo.jpg?5d2a3bf1";